/*
 * @Author: edvardchen
 * @Date:   2016-11-15 15:16:43
 * @Last Modified by: zloongjiang
 * @Last Modified time: 2021-08-13 16:35:57
 */

// @flow
import * as React from 'react';
import _ from 'lodash';
import { listen } from 'fbjs/lib/EventListener';
import cookies from 'js-cookie';
import { supportPassive } from './DOM';
import withExposureWatch from '../HOCs/withExposureWatch_new';
import { setCommonParams } from '../utility/universalReport';
import querystring from 'querystring';
export * from './DOM-detect';

const StarVideoItem = withExposureWatch(({ st = {}, kIndex = 1, data = {} }) => {
  return (
    <span
      style={st}
      key={kIndex}
      onClick={() => {
        starVideoFloat(st['star-video-tag']);
      }}
    >
      {data.txt}
      {st['star-video-tag'] && <i className="star--tag-icon" />}
    </span>
  );
});

/**
 * 元素是否露出
 * @param  {Element} elm
 * @return {Boolean}
 */
export function visible(elm: ?HTMLElement) {
  if (!elm) {
    return false;
  }
  const rect = elm.getBoundingClientRect();
  if (!rect.height && !rect.width) {
    return false;
  }
  if (rect.top < window.innerHeight && rect.bottom > 0 && rect.left < window.innerWidth && rect.right > 0) {
    // 露出
    return true;
  }
}

/**
 * 元素底部是否露出
 * @param  {Element} elm
 * @return {Boolean}
 */
export function hasReachedBottom(elm: HTMLElement) {
  if (!elm) {
    return false;
  }
  const { height, width, bottom } = elm.getBoundingClientRect();
  if (!height && !width) {
    return false;
  }
  if (bottom > 0 && bottom < window.innerHeight) {
    // 底部露出
    return true;
  }
}

/**
 * 左右滑动元素是否漏出
 * @param  {Element} elm
 * @return {Boolean}
 */
export function hasLeftReached(elm: HTMLElement, percent: number = 0.5) {
  if (!elm) {
    return false;
  }
  const { width, left } = elm.getBoundingClientRect();
  if (!left && !width) {
    return false;
  }
  const windowW = document.body.offsetWidth;
  if (windowW - left > width * percent) {
    // 左侧漏出百分比
    return true;
  }
}

/**
 * 底部元素是否到固定位置
 * @param  {Element} elm
 * @return {Boolean}
 */
export function hasOffsetBottom(elm: HTMLElement) {
  if (!elm) {
    return false;
  }
  const { height, width, bottom } = elm.getBoundingClientRect();
  if (!height && !width) {
    return false;
  }
  if (window.innerHeight - bottom > 250) {
    return true;
  }
}

/**
 * @borrows Zepto.offset as offset
 * @param  {Element} dom
 * @return {Object}
 */
export function offset(dom: HTMLElement) {
  const obj = dom.getBoundingClientRect();
  return {
    left: obj.left + window.pageXOffset,
    top: obj.top + window.pageYOffset,
    width: Math.round(obj.width),
    height: Math.round(obj.height),
  };
}

export function listenPassively(elm: any, type: string, handle: Function) {
  if (!supportPassive()) {
    return listen(elm, type, handle);
  }
  const opt = { passive: true };
  elm.addEventListener(type, handle, opt);
  return {
    remove: () => {
      elm.removeEventListener(type, handle, opt);
    },
  };
}

const DELAY = 300;
export function listenToScroll(callback: Function, interval?: number) {
  return listenPassively(window, 'scroll', _.throttle(callback, interval || DELAY, { leading: false }));
}
export function listenToLeftScroll(elm: HTMLElement, callback: Function, interval?: number) {
  return listenPassively(elm, 'scroll', _.throttle(callback, interval || DELAY, { leading: false }));
}

// 自定义轮询方法 防止 setInterval 因为方法的阻塞导致后续轮询方法 一次性执行多次
export const newsEventFncLoop = (fnc: Function, wait?: number, cancel?: Function) => {
  // eslint-disable-next-line no-param-reassign
  wait = wait || 10;
  let eventFnc = null;
  const interval = () => {
    fnc.call(null);
    if (cancel && cancel()) {
      // 用方法返回 防止作用域问题
      eventFnc && clearTimeout(eventFnc);
    } else {
      eventFnc = setTimeout(interval, wait);
    }
  };
  setTimeout(interval, wait); // 最低10ms
};

/**
 * 提取样式
 */
export const getStyleByArrayData = (styles: Array<Object>, highLevel?: boolean, grayConfig?: Object) => {
  const st = {};
  (styles || []).forEach((i) => {
    if (i.key && i.value) {
      if (
        i.key === 'tag' &&
        i.value.split('|').length === 3 &&
        _.get(grayConfig || {}, 'exp_feeds_article_searchwords_A.isAble', false)
      ) {
        st.color = '#4C9AFA';
        st['star-video-tag'] = i.value;
        return true;
      }
      if (i.key === 'color' && st.color) {
        return true;
      }
      const [key1, key2] = i.key.split('-');
      let key = key1;
      if (key2) {
        const [first = '', ...rest] = key2;
        key = [key1, first.toUpperCase()].concat(rest).join('');
      }
      st[key] = i.value + (highLevel ? '!important' : '');
    }
  });
  return st;
};
/**
 * 跳转到明星视频浮层
 */
function starVideoReport(action, tag) {
  if (!tag || tag.split('|').length < 3) return;
  const [tagId, tagName, tagType] = tag.split('|');
  beaconReport({
    key: 'starVideoLabels',
    params: {
      __action: action,
      __tagId: tagId,
      __tagName: tagName,
      __tagType: tagType,
      __guid: cookies.get('qb_guid') || '',
    },
  });
}
function starVideoFloat(tag = '') {
  if (!tag || tag.split('|').length < 3) return;
  const [tagId, tagName, tagType] = tag.split('|');
  console.log('starVideoFloat tagId=', tagId, tagName, tagType);
  // 跳转搜索
  const url = `https://m.sogou.com/web/searchList.jsp?pid=sogou-waps-3ba41430dea50a73&kdsfid=8888&keyword=${tagName}&jump_from=1_10_02_04&entryTime=&entryScene=`;
  const openUrl = _.get(window, 'browser.app.openUrl');
  openUrl
    ? openUrl(
        () => {},
        () => {},
        {
          url,
          newWindow: false,
        },
      )
    : (location.href = url);
  starVideoReport('Click', tag);
}
export function data2ContentDom(value, grayConfig) {
  if (_.isArray(value)) {
    const children = [];
    const len = value.length;
    value.forEach((data, index) => {
      const kIndex = `contentKey_${index}`;
      const st = getStyleByArrayData(data.ext, null, grayConfig);
      if (len <= 1) {
        st.display = 'block';
      }
      children.push(
        st['star-video-tag'] ? (
          <StarVideoItem
            onExposure={() => {
              starVideoReport('Exposure', st['star-video-tag']);
            }}
            st={st}
            kIndex={kIndex}
            data={data}
            wrapSpan
          />
        ) : (
          <span style={st} key={kIndex}>
            {data.txt}
          </span>
        ),
      );
    });
    return children;
  }
  return <span>{value}</span>;
}
export const beaconReport = ({ key, params }) => {
  if (!__CLIENT__) {
    return;
  }
  if (window.BeaconAction && window.newsNodeBeaconAction) {
    window.newsNodeBeaconAction.onDirectUserAction(key, params);
  } else {
    window.BeaconReportQueue = window.BeaconReportQueue || [];
    window.BeaconReportQueue.push({
      key,
      params,
    });
  }
};

export function getGrayIds() {
  const query = querystring.parse(window.location.href);
  const { extenddata = '' } = query;
  const extData = querystring.parse(extenddata || '') || {};
  const { sGrayPlatFormModelId } = extData;
  return {
    sGrayPlatFormModelId: String(sGrayPlatFormModelId || ''),
  };
}

/**
 * 在旧仓库也报一部分数据到news_h5新仓库的表里
 * @param {{
 *  eventName: string;
 *  ext1?: string;
 *  ext2?: string;
 *  ext3?: string;
 *  ext4?: string;
 *  ext5?: string;
 *  nExt1?: number;
 *  nExt2?: number;
 * }} params
 */
export const newsH5Report = (params) => {
  beaconReport({
    key: 'news_h5',
    params,
  });
};

// 页面的自定义上报udf_kv字段加私参需要放在pageParams里，元素自定义上报udf_kv字段加私参需要放在businessParams里，加公参统一放在publicParams里
/* 模版如下
  manualUniversalReport({
    pgid: 'xxx',
    eventName: 'dt_xxx', 例如dt_pgin/dt_pgout页面事件 dt_clck/dt_imp元素事件
    pageParams/businessParams/publicParams: {
      params1: xxx,
      params2: xxx,
    },
  });
*/
export const manualUniversalReport = (pgid, eventName, params, paramsType) => {
  if (!__CLIENT__) {
    return;
  }
  if (window.UniversalReport) {
    const modifiedParams = setCommonParams(params);
    if (paramsType === 'pageParams') {
      window.UniversalReport.reportEvent({ pgid, eventName, pageParams: { ...modifiedParams } });
    } else if (paramsType === 'businessParams') {
      window.UniversalReport.reportEvent({ pgid, eventName, businessParams: { ...modifiedParams } });
    } else if (paramsType === 'publicParams') {
      window.UniversalReport.reportEvent({ pgid, eventName, publicParams: { ...modifiedParams } });
    }
  }
};

export const widgetBeaconReport = ({ key, params }) => {
  if (!__CLIENT__) {
    return;
  }
  if (window.BeaconAction && window.widgetBeaconAction) {
    console.warn(key, params);
    window.widgetBeaconAction.onDirectUserAction(key, params);
  }
};

export const userCenterBeaconReport = ({ key, params }) => {
  if (!__CLIENT__) {
    return;
  }
  if (window.BeaconAction && window.userCenterBeaconAction) {
    console.warn(key, params);
    window.userCenterBeaconAction.onDirectUserAction(key, params);
  }
};
